<div id="high-charts-container" #highChartTpl></div>
